import { EndpointSetting } from "@/constants/app/type";
import { FlightState, TypeAirport } from "../type";

export const callbackGetAirports: EndpointSetting['caller'] = (
  state: FlightState,
  { payload }: any,
  endpointName: any
) => {
  state.get_airports.data = {}
  state.get_airports.primaryKeys = []
  state.get_airports.called = true
  state.get_airports.error = null
  state.get_airports.success = true

  let countries: string[] = []
  const countriesData: any = {}
  const popularCategory: any[] = []
  for (let i = 0; i < payload.length; i++) {
    // Clone so search/UI metadata later never mutates the API payload object
    const airport: TypeAirport = { ...payload[i] };
    state.get_airports.data[airport.code] = airport
    state.get_airports.primaryKeys?.push(airport.code)

    const countryCode = airport.countryCode || "QUOC_TE"

    countriesData[countryCode] = {
      name: countryCode === 'QUOC_TE' ? 'Quốc Tế' : airport.country,
      isDomestic: airport.isDomestic
    }

    if (airport.isDomestic === '1' && state.domesticAirports.indexOf(airport.code) < 0) {
      state.domesticAirports.push(airport.code)
    }

    if (airport.isPopular === '1') {
      popularCategory.push(countryCode)

      if (airport.isDomestic === '0') {
        state.internationalAirports.push(airport.code)
      }
    }

    if (!state.mappingCountriesAirports[countryCode]) {
      state.mappingCountriesAirports[countryCode] = [airport.code]
    } else {
      state.mappingCountriesAirports[countryCode].push(airport.code)
    }

    if (countries.indexOf(countryCode) < 0) {
      countries.push(countryCode)
    }
  }

  countries.reverse()
  countries = countries.sort((c1, c2) => {
    const indexC1 = popularCategory.indexOf(c1)
    const indexC2 = popularCategory.indexOf(c2)

    return indexC2 - indexC1
  })

  for (let i = 0; i < countries.length; i++) {
    const countryCode = countries[i];
    countriesData[countryCode].count = state.mappingCountriesAirports[countryCode].length
  }

  state.countryData = countriesData
  state.countryCodes = countries
}